import { cookies } from 'lib/enums';
import Backbone from 'backbone';
import FacetViews from 'app/views/store/pages/categories/facet_views';
import SelectBoxView from 'app/views/store/common/select_box';
import SocialBarView from 'app/views/store/common/social/social_bar';
import 'app/views/store/common/menu';
import CartItemModel from 'app/models/store/client/cart/item';
import 'common/calc_widgets';
import jsCookie from 'js-cookie';

export default Backbone.View.extend({
	el: '#page-content',

	events: {
		'click .js-view-change-button': '_changeViews',
		'click .js-add-to-cart': '_addToCart',
		'click .js-configure': '_configureItem',
		'click #tileView': '_toggleTileView',
		'click #listView': '_toggleListView',
		'change .js-facets': '_facetsChanged'
	},

	initialize: function(options = {}) {
		this.$gridList = $('#gridList');
		this.options = options;

		this._initChildViews();

		jsCookie.set(cookies.LASTSEARCHPAGE, window.location.href, {
			path: '/'
		});
		this._handleHash(window.location.hash);
	},
	_handleHash: function(hash) {
		if (hash) {
			const $tabs = this.$el.find('.nav-tabs a[data-toggle="tab"]');
			this._setActiveTabFromHash($tabs, hash);
			const $panels = this.$el.find('.js-facet-banners .collapse');
			this._setActivePanelFromHash($panels, hash);
		}
	},
	_setActiveTabFromHash: function($tabs, hash) {
		const $matchingTab = $tabs.filter(`[href="${hash}"]`);
		return $matchingTab.tab && $matchingTab.tab('show');
	},
	_setActivePanelFromHash: function($panels, hash) {
		const $panel = $panels.filter(hash);
		if ($panel.length && !$panel.hasClass('in')) {
			// collapses open accordion panels before opening the target
			// bootstrap 3 does not close the other panels for you
			$panels
				.filter('.collapse.in')
				.collapse('hide')
				.end()
				.filter(hash)
				.collapse('show');
		}
	},
	_initChildViews: function() {
		const startFacetListCollapsed = this.options.hasOwnProperty('startFacetListCollapsed')
				? this.options.startFacetListCollapsed
				: true,
			hasUnderlay = !window.BCOM.device.isDesktop;
		this.childViews = {
			facetViews: new FacetViews({
				facetListView: { enabled: true, el: '.js-facet-options', startCollapsed: startFacetListCollapsed },
				facetListModal: { enabled: true, el: '.js-facet-options-modal', startCollapsed: startFacetListCollapsed },
				facetMenuView: { enabled: true, hasUnderlay: hasUnderlay },
				getQueryParams: this.getQueryParams.bind(this),
				onFacetsChange: this._onFacetViewsChange.bind(this)
			}),
			sortBy: new SelectBoxView({
				el: $('.js-sort-by'),
				model: new Backbone.Model(window.dataLayer.sortBy),
				onChange: this._onSortByChange.bind(this)
			}),
			social: new SocialBarView()
		};
		this.childViews.pagination = $('.js-pagination-component').data('componentView');
		if (window.dataLayer.canElevateSearchResults) {
			import('app/views/store/pages/categories/elevate_tool').then((ElevateTool) => {
				this.childViews.elevateTool = new ElevateTool.ElevateToolView();
			});
			import('app/views/store/pages/categories/elevate_buttons').then((ElevateButtons) => {
				this.childViews.elevateButton = new ElevateButtons.ElevateButtonsView();
			});
		}
	},

	_toggleTileView: function() {
		const cookiedate = new Date();
		cookiedate.setTime(cookiedate.getTime() + 1000 * 24 * 60 * 60 * 1000);
		this.$gridList.removeClass('listview');
		this.$gridList
			.find('.productListing')
			.removeClass('col-xs-12')
			.addClass('col-xs-6 col-sm-4 col-md-4 col-lg-3');
		this.$gridList.find('.productImageContainer').removeClass('col-xs-4 col-sm-3');
		this.$gridList.find('.productDetailsContainer').removeClass('col-xs-8 col-sm-9');
		this.$gridList.find('.productDetailsBlock').removeClass('col-xs-12 col-sm-8');
		this.$gridList.find('.productPricingContainer').removeClass('col-xs-12 col-sm-4');
		this.$gridList.addClass('tileview');
		jsCookie.set(cookies.GRID_VIEW, 'tile', {
			expires: cookiedate,
			path: '/'
		});
	},

	_toggleListView: function() {
		const cookiedate = new Date();
		cookiedate.setTime(cookiedate.getTime() + 1000 * 24 * 60 * 60 * 1000);
		this.$gridList.removeClass('tileView');
		this.$gridList
			.find('.productListing')
			.removeClass('col-xs-6 col-sm-4 col-md-4 col-lg-3')
			.addClass('col-xs-12');
		this.$gridList.addClass('listview');
		this.$gridList.find('.productImageContainer').addClass('col-xs-4 col-sm-3');
		this.$gridList.find('.productDetailsContainer').addClass('col-xs-8 col-sm-9');
		this.$gridList.find('.productDetailsBlock').addClass('col-xs-12 col-sm-8');
		this.$gridList.find('.productPricingContainer').addClass('col-xs-12 col-sm-4');
		jsCookie.set(cookies.GRID_VIEW, 'row', {
			expires: cookiedate,
			path: '/'
		});
	},

	_addToCart: function(event) {
		event.preventDefault();

		var $btn = $(event.currentTarget),
			cartItem = new CartItemModel({
				quantity: 1,
				uniqueId: $btn.next('input').val()
			});
		$btn.button('loading');
		cartItem.save(null, {
			success: (model, response) => {
				if (model.get('status') === 1) {
					window.BCOM.notifications.render(
						'You have added an item to your cart <a href="/checkout/cart" class="btn ml3">View Cart</a>',
						'success'
					);
					window.BCOM.util.trackCartAddition(model.attributes);
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger('cart:quantityChanged', model.get('cart').quantity);
					Backbone.trigger('omniture:productaddtocart', 'search-page', response, model, null);
				} else {
					window.BCOM.notifications.render('There was a problem adding this item to your cart. Please try again.', 'danger');
				}
				$btn.button('reset');
			}
		});
	},
	_configureItem: function(e) {
		e.preventDefault();
		const $btn = $(e.currentTarget);
		window.location.assign(`${$btn.next('input').val()}/configure?quantity=1&save=all`);
	},

	getQueryParams() {
		const queryParams = this.childViews.facetViews.getFacetQueries(),
			pageSize = this.childViews.pagination.getPageSize(),
			sortBy = this.childViews.sortBy.getSelectedValue(),
			page = this.childViews.pagination.getActivePage(),
			dl = window.dataLayer;

		if (window.location.search.indexOf('?view=all') >= 0) {
			queryParams.unshift('view=all');
		}

		queryParams.push(`r=${pageSize || dl.pagination.pageSize}`);

		if (sortBy || dl.sortBy) {
			queryParams.push(`s=${sortBy || dl.sortBy.selectedValue}`);
		}
		if (page) {
			queryParams.push(`p=${page}`);
		}
		if (dl.categoryId) {
			queryParams.push(`categoryId=${dl.categoryId}`);
		}
		if (dl.search) {
			queryParams.push(`term=${dl.search.name}`);
		}
		return queryParams;
	},

	_onFacetViewsChange: function() {
		// if we wanted to go async, we would branch some logic right here e.g. search.page.js
		window.location.search = this.getQueryParams().join('&');
	},

	// handles the <select> change events for the facet ui at mobile
	_facetsChanged: function(e) {
		const $dropDown = $(e.currentTarget),
			url = String($dropDown.val());

		if (url) {
			window.location.assign(url);
		}
	},

	_onSortByChange: function(value) {
		window.BCOM.util.trackSortBy(value);
	}
});
